<template>
  <b-card-body>
    <h5>{{ $t('question') }}</h5>
    <div v-for="alternative in question.alternatives" :key="alternative.id">
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input readonly v-model="question.value1"/>
            <b-form-input readonly v-model="alternative.value1"/>
            <b-form-input readonly v-model="question.value2"/>
            <b-form-input readonly v-model="alternative.value2" />
            <b-form-input readonly v-model="question.value3"/>
            <b-form-input readonly v-model="equals"/>
            <b-form-input readonly v-model="question.value4"/>
          </b-input-group>
        </b-col>
      </b-row>
    </div>
  </b-card-body>
</template>

<script>

export default {
  name: 'display-module-gnum',
  props: {
    question: {}
  },
  data() {
    return {
      equals: '='
    }
  }
}
</script>
